import * as Yup from 'yup';

import { EIV_CHAR_LENGTH, TENANT_ID, VALIDATION_CONSTANTS } from 'global/constants';

import { YPhoneNumber } from 'utils/YupUtils';
import { getTenantId } from 'utils/tenantUtil';

export const YDebFIFormSchema = () =>
  Yup.object().shape({
    companyName1: Yup.string()
      .required(VALIDATION_CONSTANTS.MANDATORY)
      .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
      .max(EIV_CHAR_LENGTH.FIRMENNAME1, VALIDATION_CONSTANTS.TOO_LONG),
    companyName2: Yup.lazy((value) => {
      if (value !== undefined && value !== '') {
        return Yup.string()
          .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
          .max(EIV_CHAR_LENGTH.FIRMENNAME2, VALIDATION_CONSTANTS.TOO_LONG);
      }
      return Yup.string().nullable().optional();
    }),
    companyName3: Yup.lazy((value) => {
      if (value !== undefined && value !== '') {
        return Yup.string()
          .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
          .max(EIV_CHAR_LENGTH.FIRMENNAME2, VALIDATION_CONSTANTS.TOO_LONG);
      }
      return Yup.string().nullable().optional();
    }),
    companyCountry: Yup.string().required(VALIDATION_CONSTANTS.MANDATORY),
    companyOwner: Yup.lazy(() => {
      if (TENANT_ID.BAG === getTenantId()) {
        return Yup.string()
          .required(VALIDATION_CONSTANTS.MANDATORY)
          .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
          .max(EIV_CHAR_LENGTH.FIRMENNAME3, VALIDATION_CONSTANTS.TOO_LONG);
      }
      return Yup.string().nullable().optional();
    }),
    companyStreet: Yup.string()
      .required(VALIDATION_CONSTANTS.MANDATORY)
      .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
      .max(EIV_CHAR_LENGTH.BUERO_STRASSE, VALIDATION_CONSTANTS.TOO_LONG),
    companyHouseNumber: Yup.string()
      .required(VALIDATION_CONSTANTS.MANDATORY)
      .min(1, VALIDATION_CONSTANTS.TOO_SHORT)
      .max(EIV_CHAR_LENGTH.BUERO_HAUSNUMMER, VALIDATION_CONSTANTS.TOO_LONG),
    companyPostal: Yup.lazy((value, context) => {
      if (context?.parent?.companyCountry === 'DE') {
        return Yup.string()
          .required(VALIDATION_CONSTANTS.MANDATORY)
          .min(5, VALIDATION_CONSTANTS.TOO_SHORT)
          .max(EIV_CHAR_LENGTH.BUERO_PLZ, VALIDATION_CONSTANTS.TOO_LONG);
      }
      return Yup.string()
        .required(VALIDATION_CONSTANTS.MANDATORY)
        .min(4, VALIDATION_CONSTANTS.TOO_SHORT)
        .max(EIV_CHAR_LENGTH.BUERO_PLZ, VALIDATION_CONSTANTS.TOO_LONG);
    }),
    companyCity: Yup.string()
      .required(VALIDATION_CONSTANTS.MANDATORY)
      .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
      .max(EIV_CHAR_LENGTH.BUERO_ORT, VALIDATION_CONSTANTS.TOO_LONG),
    companyPostalCity: Yup.lazy((value, context) => {
      if (context?.parent?.companyCountry === 'DE') {
        return Yup.string().required(VALIDATION_CONSTANTS.MANDATORY);
      }
      return Yup.string().nullable().optional();
    }),
    companyStreetId: Yup.lazy((value, context) => {
      if (context?.parent?.companyCountry === 'DE') {
        return Yup.string().required(VALIDATION_CONSTANTS.MANDATORY);
      }
      return Yup.string().nullable().optional();
    }),
    companyRegionId: Yup.lazy((value, context) => {
      if (context?.parent?.companyCountry === 'DE' && value !== undefined && value !== '') {
        return Yup.string().min(1, VALIDATION_CONSTANTS.TOO_SHORT);
      }
      return Yup.string().nullable().optional();
    }),
    companyRegion: Yup.lazy((value) => {
      if (value !== undefined && value !== '') {
        return Yup.string()
          .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
          .max(EIV_CHAR_LENGTH.BUERO_ORTSTEIL, VALIDATION_CONSTANTS.TOO_LONG);
      }
      return Yup.string().nullable().optional();
    }),
    companyHouseNumberAddition: Yup.lazy((value) => {
      if (value !== undefined && value !== '') {
        return Yup.string()
          .min(1, VALIDATION_CONSTANTS.TOO_SHORT)
          .max(EIV_CHAR_LENGTH.BUERO_HAUSNUMMERZUSATZ || 10, VALIDATION_CONSTANTS.TOO_LONG);
      }
      return Yup.string().nullable().optional();
    }),
    mobile: Yup.lazy((value) => {
      if (value !== undefined && value !== '') {
        return YPhoneNumber;
      }
      return Yup.string()
        .nullable()
        .optional()
        .test('mobile-or-phone-required', VALIDATION_CONSTANTS.MANDATORY, function (val) {
          return !!(val || this.parent.phone);
        });
    }),
    phone: Yup.lazy((value) => {
      if (value !== undefined && value !== '') {
        return YPhoneNumber;
      }
      return Yup.string()
        .nullable()
        .optional()
        .test('mobile-or-phone-required', VALIDATION_CONSTANTS.MANDATORY, function (val) {
          return !!(val || this.parent.mobile);
        });
    }),
    email: Yup.string()
      .email(VALIDATION_CONSTANTS.INVALID_EMAIL)
      .required(VALIDATION_CONSTANTS.MANDATORY),
    experts: Yup.array().min(1, VALIDATION_CONSTANTS.MANDATORY),
  });
